import React from 'react'
import { View } from 'react-native'
import { useNavigation, useRoute } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { useSelector } from 'react-redux'
import pluralize from 'pluralize'
import { BottomSheet } from '@src/components'
import { Text } from '@src/components/base'
import { AppRouteProp, AppStackParamList } from '@src/navigation/types'
import { userSelector } from '@src/selectors/app'
import { StyleService } from '@src/style/service'

export const GiveFeedbackModal = () => {
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const route = useRoute<AppRouteProp<'GiveFeedbackModal'>>()
  const { questionnaire, questionsCount, durationInMinutes } = route.params
  const user = useSelector(userSelector)

  const onPress = () => {
    navigation.replace('Questionnaire', {
      questionnaire,
    })
  }

  return (
    <BottomSheet
      header={`Hi ${user?.firstName}! 👋`}
      showDismissButton
      dismissButtonPosition="top"
      primaryButton={{
        text: 'Start Survey',
        onPress,
      }}
    >
      <View style={styles.container}>
        <Text type="regular" style={styles.textCenter}>
          We’d love your quick feedback to help make Nutrisense even better.
        </Text>
        <Text type="regular" style={styles.textCenter}>
          It’s just {questionsCount}{' '}
          <Text type="regular" bold>
            short {pluralize('question', questionsCount)}
          </Text>{' '}
          and takes less than {pluralize('minute', durationInMinutes, true)}.
        </Text>
      </View>
    </BottomSheet>
  )
}

const styles = StyleService.create({
  container: {
    marginBottom: 24,
  },
  textCenter: {
    textAlign: 'center',
  },
})
